import React, { useState, useEffect } from 'react';
import { CheckCircle, AlertCircle, XCircle, Info, X } from 'lucide-react';

const Notification = ({ type = 'info', message, onClose, autoClose = true, duration = 5000 }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (autoClose && isVisible) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                if (onClose) onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [autoClose, duration, isVisible, onClose]);

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) onClose();
    };

    if (!isVisible) {
        return null;
    }

    let Icon, bgColor, borderColor, textColor;

    switch (type) {
        case 'success':
            Icon = CheckCircle;
            bgColor = 'bg-green-50';
            borderColor = 'border-green-400';
            textColor = 'text-green-800';
            break;
        case 'error':
            Icon = XCircle;
            bgColor = 'bg-red-50';
            borderColor = 'border-red-400';
            textColor = 'text-red-800';
            break;
        case 'warning':
            Icon = AlertCircle;
            bgColor = 'bg-yellow-50';
            borderColor = 'border-yellow-400';
            textColor = 'text-yellow-800';
            break;
        case 'info':
        default:
            Icon = Info;
            bgColor = 'bg-blue-50';
            borderColor = 'border-blue-400';
            textColor = 'text-blue-800';
            break;
    }

    return (
        <div className={`${bgColor} border-l-4 ${borderColor} p-4 mb-6 relative`}>
            <div className="flex items-start">
                <div className="flex-shrink-0">
                    <Icon className={`h-5 w-5 ${textColor.replace('800', '500')}`} />
                </div>
                <div className="ml-3 mr-8">
                    <p className={`text-sm ${textColor}`}>{message}</p>
                </div>
                <button
                    className={`absolute right-2 top-2 ${textColor.replace('800', '500')} hover:${textColor.replace('800', '700')}`}
                    onClick={handleClose}
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
};

export default Notification;